import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { 
  ArrowRight, Sparkles, Users, TrendingUp, 
  ShieldCheck, Heart, ChevronRight, Plus, 
  Minus, CreditCard, Zap, Check, Lock, Star,
  MessageCircle, HelpCircle, Target
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

// Reaproveitando a lógica de preços do seu app
const plans = [
  {
    id: "pix_31",
    name: "Acesso Avulso (31 dias)",
    price: "R$ 9,90",
    billingNote: "Pagamento único via PIX",
    pricePerMonth: "Sem renovação",
    tagline: "Pague e use! Sem letras miúdas. ⚡",
    savings: "Sem compromisso",
    recommended: true,
    cta: "Liberar 31 dias"
  },
  {
    id: "monthly",
    name: "Modo Piloto Automático",
    price: "R$ 9,90",
    billingNote: "Assinatura Mensal",
    pricePerMonth: "Renovação Automática",
    tagline: "O Mercado Pago cuida de tudo. 🤖",
    savings: "Mais praticidade",
    recommended: false,
    cta: "Ativar renovação"
  }
];

export default function LandingPage() {
  const [oracleQuestion, setOracleQuestion] = useState("");
  const [oracleAnswer, setOracleAnswer] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  // Simulação do Oráculo para a Landing Page
  const handleOracleTeaser = () => {
    if (!oracleQuestion) return;
    setIsTyping(true);
    const answers = [
      "Spoiler: ignorar o saldo não melhora o saldo.",
      "Seu futuro agradece cada decisão menos impulsiva de hoje.",
      "Não é sobre cortar tudo... é sobre parar de se sabotar.",
      "Parcelado parece leve... até virar uma coleção.",
      "Gastar você já sabe. Bora aprender a acompanhar também."
    ];
    setTimeout(() => {
      setOracleAnswer(answers[Math.floor(Math.random() * answers.length)]);
      setIsTyping(false);
    }, 800);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-slate-900 selection:bg-indigo-100">
      
{/* Navbar Minimalista (Estilo App) */}
      <nav className="fixed top-0 w-full z-50 bg-white/80 backdrop-blur-xl border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          
          {/* LOGO INSERIDO AQUI */}
          <div className="flex items-center gap-2">
            <Link to="/">
              <img 
                src="/logo-troquinho.png"  // <-- COLOQUE O NOME DO SEU ARQUIVO AQUI
                alt="Troquinho Logo" 
                className="h-12 w-auto object-contain hover:opacity-80 transition-opacity" 
              />
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-10 text-[15px] font-semibold text-slate-700">
            <a href="#sobre" className="hover:text-indigo-600 transition-all">Sobre</a>
            <a href="#features" className="hover:text-indigo-600 transition-all">Funcionalidades</a>
            <a href="#pricing" className="hover:text-indigo-600 transition-all">Planos</a>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/login" className="text-sm font-black text-indigo-600 px-4 py-2 hover:bg-indigo-50 rounded-xl transition-all"> Entrar
</Link>
            <Link to="/register">
              <Button size="sm" className="rounded-xl font-bold px-7 bg-indigo-600 hover:bg-indigo-700 shadow-md">
                Criar Conta
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section - A cara do App */}
      <section className="relative pt-32 pb-20 px-6 overflow-hidden">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 border border-indigo-100 text-indigo-600 font-bold text-[10px] uppercase tracking-wider mb-6">
              <Sparkles className="w-3.5 h-3.5" />
              <span>Organização financeira inteligente</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-black text-slate-900 mb-6 leading-[0.95] tracking-tighter">
              Seu dinheiro <br />
              <span className="text-indigo-600 underline decoration-indigo-200 underline-offset-8">Sem drama.</span>
            </h1>
          <p className="text-lg md:text-xl text-slate-500 font-medium max-w-lg mb-10 leading-relaxed">
            O app que entende como a vida acontece. <br className="hidden md:block" /> 
            <span className="text-slate-900 font-bold underline decoration-indigo-100 decoration-4 underline-offset-4">Organize suas finanças sozinho ou em grupo!</span>
          </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/register">
                <Button className="h-16 px-10 rounded-[20px] font-black text-lg shadow-xl shadow-indigo-200 bg-indigo-600 hover:bg-indigo-700 transition-all hover:scale-[1.02] active:scale-95">
                  Começar — 7 dias grátis
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
              {/* Link de reativação abaixo do botão principal */}
<Link to="/login" className="flex items-center justify-center sm:justify-start gap-2 text-slate-400 hover:text-indigo-600 font-bold text-xs transition-colors ml-2 mt-2">
  <Users className="w-3 h-3" />
  Quer reativar sua assinatura? Clique aqui.
</Link>
            </div>
          </motion.div>

          {/* "Mockup" do App - Usando o estilo do seu print */}
{/* Mockup Real do App Inserido Aqui */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
            className="relative flex justify-center lg:justify-end"
          >
            <div className="relative max-w-[300px] sm:max-w-[340px]">
              {/* A Imagem com borda de celular */}
              <img 
                src="/mockup-app.png" 
                alt="Interface do Troquinho" 
                className="w-full h-auto rounded-[45px] shadow-[0_20px_60px_rgba(0,0,0,0.15)] border-[8px] border-slate-900 relative z-10"
              />
              
              {/* Brilho decorativo atrás da imagem */}
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-indigo-400/20 rounded-full blur-[80px]" />
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-emerald-400/20 rounded-full blur-[80px]" />
            </div>
          </motion.div>
        </div>
      </section>

 {/* Seção Sobre - Texto Original + Print Ranking */}
<section id="sobre" className="py-24 px-6 bg-white overflow-hidden">
  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
    
    {/* Coluna de Texto: Conteúdo Original */}
    <div className="flex flex-col gap-6">
      <h2 className="text-3xl md:text-5xl font-black tracking-tighter text-slate-900 leading-[1.1]">
        Dinheiro compartilhado <br />
        <span className="text-indigo-600 italic">sem dor de cabeça.</span>
      </h2>

      <div className="space-y-6 text-lg md:text-xl text-slate-600 font-medium leading-relaxed">
        <p>
          O Troquinho nasceu para ajudar pessoas que dividem a vida e, também, as contas.
        </p>
        <p>
          Veja quem gastou o quê, acompanhe as despesas e entenda para onde o seu dinheiro realmente está indo.
        </p>
        <p className="text-slate-400 italic">
          Tudo de um jeito simples, leve e transparente. <br className="hidden md:block" />
          Sem planilhas confusas. Sem cobranças desconfortáveis.
        </p>
      </div>

      <div className="pt-6 border-t border-slate-100 uppercase tracking-[0.2em] font-black text-indigo-500 text-sm">
        Dividir contas sem dividir relações.
      </div>
    </div>

    {/* Coluna da Imagem: Print Ranking Inimigos */}
    <div className="relative flex justify-center lg:justify-end">
      <div className="relative max-w-[340px]">
        {/* A moldura branca faz o print do app "saltar" na página */}
        <img 
          src="/ranking-inimigos.png"  // <-- Substitua pelo nome do seu arquivo do print do ranking
          alt="Ranking Inimigos do Fim do Mês" 
          className="w-full h-auto rounded-[32px] shadow-[0_20px_50px_rgba(0,0,0,0.1)] border-[8px] border-slate-50 relative z-10"
        />
        
        {/* Detalhe visual de fundo para dar profundidade */}
        <div className="absolute -z-10 inset-0 bg-indigo-50 rounded-[40px] rotate-3 scale-105" />
      </div>
    </div>

  </div>
</section>

{/* Bloco de Funcionalidades - Texto Refinado */}
<section id="features" className="py-24 px-6 bg-slate-50/50">
  <div className="max-w-7xl mx-auto">
    
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-5xl font-black tracking-tighter text-slate-900">
        A vida é complexa, <br className="md:hidden" /> 
        seu controle financeiro não.
      </h2>
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      
      {/* Feature 1: Contas Compartilhadas */}
      <div className="bg-white p-8 rounded-[32px] border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-indigo-50 transition-all group">
        <div className="w-14 h-14 bg-indigo-50 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
          <Users className="w-7 h-7 text-indigo-600" />
        </div>
        <h3 className="text-xl font-black mb-3 text-slate-900">Contas compartilhadas</h3>
        <p className="text-slate-500 font-medium leading-relaxed">
          Divida aluguel, mercado e streaming sem confusão. O Troquinho mostra quem gastou o quê de forma simples, clara e justa.
        </p>
      </div>

      {/* Feature 2: Metas (Juntar Dinheiro) */}
      <div className="bg-white p-8 rounded-[32px] border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-emerald-50 transition-all group">
        <div className="w-14 h-14 bg-emerald-50 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
          <Target className="w-7 h-7 text-emerald-600" />
        </div>
        <h3 className="text-xl font-black mb-3 text-slate-900">Juntar dinheiro sem climão</h3>
        <p className="text-slate-500 font-medium leading-relaxed">
          Crie metas com amigos, casal ou família. Porque sonhar junto é bom. Realizar juntos é melhor ainda.
        </p>
      </div>

      {/* Feature 3: Relatórios */}
      <div className="bg-white p-8 rounded-[32px] border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-amber-50 transition-all group">
        <div className="w-14 h-14 bg-amber-50 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
          <TrendingUp className="w-7 h-7 text-amber-600" />
        </div>
        <h3 className="text-xl font-black mb-3 text-slate-900">Relatórios que fazem sentido</h3>
        <p className="text-slate-500 font-medium leading-relaxed">
          Nada de gráficos impossíveis de entender. Veja para onde o dinheiro está indo, quanto sobra no mês e onde dá para melhorar.
        </p>
      </div>

    </div>
  </div>
</section>

    {/* Seção de Relatórios - Visual e Simples */}
<section id="relatorios" className="py-24 px-6 bg-white">
  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
    
    {/* Lado Esquerdo: Imagem do Relatório */}
    <motion.div 
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      className="relative order-2 lg:order-1 flex justify-center"
    >
      <div className="relative max-w-[320px]">
        <img 
          src="/mockup-relatorios.png" // Use aquele print que tem o Saldo, Entrou e Saiu
          alt="Relatórios do Troquinho" 
          className="w-full h-auto rounded-[40px] shadow-[0_20px_50px_rgba(0,0,0,0.1)] border-[6px] border-white"
        />
        {/* Enfeite sutil atrás da imagem para dar profundidade */}
        <div className="absolute -z-10 inset-0 bg-indigo-50 rounded-[50px] rotate-3 scale-105" />
      </div>
    </motion.div>

    {/* Lado Direito: Texto Explicativo Novo */}
    <div className="order-1 lg:order-2">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 font-bold text-[11px] uppercase tracking-wider mb-6">
        <TrendingUp className="w-4 h-4" />
        <span>Clareza Total</span>
      </div>
      <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 leading-tight tracking-tighter">
        Relatórios que <br />
        <span className="text-indigo-600">fazem sentido.</span>
      </h2>
      <p className="text-xl text-slate-600 font-bold mb-4">
        Entenda seus gastos sem decifrar gráfico maluco.
      </p>
      <p className="text-lg text-slate-500 font-medium mb-8 leading-relaxed">
        O Troquinho transforma números em respostas simples. Saiba exatamente quanto entrou, quanto saiu e quem são os maiores "vilões" do orçamento.
      </p>
      
      <ul className="grid gap-4">
        {[
          "Gastos por categoria",
          "Quem gastou o quê",
          "Categorias do seu jeito (“Delivery emocional” vale)",
          "Pix sem textão: copie, cole e cobre"
        ].map((item) => (
          <li key={item} className="flex items-start gap-3 font-bold text-slate-700">
            <div className="mt-1 w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center shrink-0">
              <Check className="w-3 h-3" />
            </div>
            {item}
          </li>
        ))}
      </ul>
    </div>

  </div>
</section>

      {/* Pricing Section - Informativa + 7 Dias Grátis */}
<section id="pricing" className="py-24 px-6 bg-slate-50">
  <div className="max-w-6xl mx-auto">
    
    {/* Headline com Foco no Teste Grátis */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-5xl font-black tracking-tighter mb-4 text-slate-900">Seu dinheiro, suas regras.</h2>
      <div className="inline-block bg-indigo-600 text-white px-6 py-2 rounded-2xl font-black text-lg shadow-xl shadow-indigo-100 mb-6">
        7 dias grátis para testar tudo.
      </div>
      <p className="text-slate-500 font-bold text-lg italic">Sem cartão. Sem compromisso. Sem climão.</p>
    </div>

    {/* Banner de Benefícios (Mantido) */}
    <div className="max-w-3xl mx-auto bg-white rounded-[32px] p-8 mb-12 border border-dashed border-indigo-200 shadow-sm relative overflow-hidden text-center lg:text-left">
        <p className="text-[11px] font-black text-indigo-600 uppercase tracking-[0.2em] mb-6 text-center">O que você leva (sem exceção):</p>
        <div className="grid md:grid-cols-2 gap-4">
            {[
                "Transações ilimitadas (anote até o cafezinho)", 
                "Relatórios simples e claros", 
                "Metas compartilhadas sem climão", 
                "Divisão de contas sem calculadora"
            ].map((b) => (
                <div key={b} className="flex items-center gap-3 text-sm font-bold text-slate-700">
                    <div className="bg-emerald-100 p-1 rounded-full text-emerald-600 shrink-0">
                        <Check className="w-3 h-3" />
                    </div>
                    {b}
                </div>
            ))}
        </div>
    </div>

    {/* Grid de Planos (Informativo - Sem botões internos) */}
    <div className="grid grid-cols-1 md:grid-cols-2 max-w-3xl mx-auto gap-8 mb-12">
      {plans.map((plan) => (
        <motion.div
          key={plan.id}
          whileHover={{ y: -5 }}
          className={`bg-white rounded-[32px] p-8 border-2 transition-all relative flex flex-col ${
            plan.recommended ? "border-indigo-600 shadow-2xl scale-105 z-10" : "border-slate-100"
          }`}
        >
          {plan.recommended && (
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-indigo-600 text-white text-[10px] font-black px-4 py-1 rounded-full uppercase tracking-widest shadow-lg">
              Rápido e Seguro ✨
            </div>
          )}
          
          <div className="mb-6">
            <h3 className={`text-xl font-black mb-1 ${plan.recommended ? "text-indigo-600" : "text-slate-900"}`}>{plan.name}</h3>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-tighter">{plan.tagline}</p>
          </div>
          
          <div className="mb-6">
            <span className="text-3xl font-black text-slate-900">{plan.price}</span>
            <p className="text-[10px] text-slate-400 font-bold italic mt-1">{plan.billingNote}</p>
          </div>

          <div className="bg-emerald-50 text-emerald-700 px-3 py-1.5 rounded-xl text-[10px] font-black inline-block mb-6 w-fit">
            {plan.savings}
          </div>

          <div className="mt-auto">
            <div className="flex items-center gap-2 bg-slate-50 p-2 rounded-lg">
                <Zap className="w-3 h-3 text-amber-500 fill-amber-500" />
                <span className="text-[11px] font-bold text-slate-600">{plan.pricePerMonth}</span>
            </div>
          </div>
        </motion.div>
      ))}
    </div>

    {/* Banner de Reativação para ex-assinantes */}
<div className="max-w-2xl mx-auto bg-indigo-50/50 border border-indigo-100 rounded-[24px] p-6 text-center mb-10">
  <p className="text-indigo-900 font-black mb-1 text-sm">Sua conta expirou?</p>
  <p className="text-slate-600 text-xs font-medium mb-3">
    Seus dados estão protegidos. Seu histórico também. Nós não julgamos... só registramos.
    Basta entrar na sua conta e escolher o plano que preferir.
  </p>
  <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
    <Link to="/login" className="text-indigo-600 font-black text-xs underline underline-offset-4 hover:text-indigo-700">
      Fazer login para recuperar acesso
    </Link>
    <span className="hidden sm:block text-slate-300">|</span>
    <a href="mailto:contato@apptroquinho.com.br" className="flex items-center gap-1 text-slate-500 font-bold text-xs hover:text-indigo-600 transition-colors">
      <HelpCircle className="w-3 h-3" />
      Precisa de ajuda? Fale conosco
    </a>
  </div>
</div>


    {/* Botão Único de Chamada para Ação (CTA) */}
    <div className="text-center px-4 md:px-0">
  <Link to="/register" className="block sm:inline-block w-full sm:w-auto">
    <Button className="w-full sm:w-auto h-16 md:h-20 px-6 md:px-14 rounded-[20px] md:rounded-[30px] font-black text-lg md:text-2xl bg-indigo-600 hover:bg-indigo-700 shadow-2xl shadow-indigo-200 transition-all hover:scale-[1.02] active:scale-95 flex items-center justify-center">
      <span className="whitespace-nowrap">Começar meus 7 dias grátis</span>
      <ArrowRight className="w-5 h-5 md:w-7 md:h-7 ml-3 shrink-0" />
    </Button>
  </Link>
  <p className="mt-6 text-slate-400 font-bold text-xs md:text-sm italic">
    A gente te avisa quando o teste estiver acabando. Sem pegadinhas.
  </p>
</div>

  </div>
</section>

      {/* Footer CTA */}
      {/* Footer Final com Termos e Segurança */}
<footer className="py-24 px-6 text-center bg-white border-t border-slate-50">
  <div className="max-w-2xl mx-auto">
    <h2 className="text-4xl font-black tracking-tighter mb-6 italic text-indigo-600 leading-tight">
      Não é dieta financeira. <br /> É só parar de exagerar sem perceber.
    </h2>
    <p className="text-slate-500 font-bold mb-6 text-lg leading-relaxed">
      Junte-se a quem já descobriu que dividir contas não precisa dividir relações.
    </p>

    {/* E-mail de suporte inserido aqui */}
    <div className="mb-10">
      <a 
        href="mailto:contato@apptroquinho.com.br" 
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-slate-50 text-slate-600 font-bold text-sm hover:bg-indigo-50 hover:text-indigo-600 transition-all border border-slate-100"
      >
        <MessageCircle className="w-4 h-4 text-indigo-500" />
        contato@apptroquinho.com.br
      </a>
    </div>
    <Link to="/register">
      <Button size="lg" className="h-20 px-12 rounded-[28px] font-black text-2xl bg-indigo-600 hover:bg-indigo-700 shadow-2xl transition-all hover:scale-105 active:scale-95">
        Criar meu Troquinho agora
      </Button>
    </Link>
    
    {/* Selos de Confiança Reais */}
    <div className="mt-16 flex flex-wrap justify-center gap-8 text-slate-400 grayscale opacity-70 mb-10">
      <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em]"><ShieldCheck className="w-4 h-4 text-indigo-500" /> 100% Seguro</div>
      <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em]"><Zap className="w-4 h-4 text-amber-500" /> Teste Grátis</div>
      <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em]"><Star className="w-4 h-4 text-indigo-500" /> Sem Letras Miúdas</div>
    </div>

    {/* Links Legais e Criptografia (Igual ao seu Registro) */}
    <div className="space-y-6 pt-10 border-t border-slate-100">
      <p className="text-[11px] text-slate-400 leading-relaxed font-medium">
        Ao usar o Troquinho, você concorda com nossos{" "}
        <Link to="/legal" className="text-indigo-600 font-bold underline">
          Termos de Uso
        </Link>{" "}
        e nossa{" "}
        <Link to="/legal" className="text-indigo-600 font-bold underline">
          Política de Privacidade
        </Link>.
      </p>

      <div className="flex justify-center items-center gap-2 py-2 px-4 bg-slate-50 rounded-full mx-auto w-fit border border-slate-100">
        <Lock className="w-3 h-3 text-indigo-600" />
        <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
          Dados Financeiros Criptografados
        </span>
      </div>

      <p className="text-[10px] text-slate-300 font-black uppercase tracking-[0.5em]">
        Troquinho © 2025 — Design Premium
      </p>
    </div>
  </div>
</footer>
    </div>
  );
}